import { useEffect, useState } from 'react';
import { useVoiceActivityContext } from '../../context/VoiceActivityContext';
import useWSTurnState from '../../hooks/useWSTurnState';
import CountdownClock from '../ui/CountdownClock';

const MAX_TIME = 30; // segundos máximos para completar

/**
 * Countdown inteligente para completação de frase
 * Dispara countdown quando atingir 2/3 do tempo máximo
 */
export default function SmartCompletionCountdown({
  allPrefixedWordsCorrect: _allPrefixedWordsCorrect, // eslint-disable-line no-unused-vars
  spokenContinuation,
  continuationProgress,
  onSendAction
}) {
  const { turnElapsedSeconds } = useWSTurnState();
  const { state: voiceState, duration: voiceDuration } = useVoiceActivityContext();
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdownSeconds, setCountdownSeconds] = useState(0);

  // Detecta se a continuação termina com pontuação
  const endsWithPunctuation = /[.!?]\s*$/.test(spokenContinuation || '');

  // Converte duração de ms para segundos
  const silenceDuration = voiceState !== 'speaking' ? voiceDuration / 1000 : 0;

  // Triggers para disparar countdown (ordem de prioridade)
  useEffect(() => {
    if (showCountdown) return; // Já disparou, não dispara de novo

    // Trigger 1 (maior prioridade): 100% do progresso → 3 segundos
    if (continuationProgress >= 100) {
      setCountdownSeconds(3);
      setShowCountdown(true);
      return;
    }

    // Trigger 2: 50% do progresso + termina com pontuação → 5 segundos
    if (continuationProgress >= 50 && endsWithPunctuation) {
      setCountdownSeconds(5);
      setShowCountdown(true);
      return;
    }

    // Trigger 3: 50% do progresso + 2 segundos sem falar → 5 segundos
    if (continuationProgress >= 50 && silenceDuration >= 2) {
      setCountdownSeconds(5);
      setShowCountdown(true);
      return;
    }

    // Trigger 4 (fallback): 2/3 do tempo máximo → tempo restante
    const twoThirdsTime = Math.floor(MAX_TIME * 2 / 3);
    if (turnElapsedSeconds >= twoThirdsTime) {
      const remainingTime = MAX_TIME - turnElapsedSeconds;
      if (remainingTime > 0) {
        setCountdownSeconds(remainingTime);
        setShowCountdown(true);
      }
    }
  }, [turnElapsedSeconds, continuationProgress, endsWithPunctuation, silenceDuration, showCountdown]);

  const handleComplete = () => {
    if (onSendAction) {
      onSendAction();
    }
  };

  return (
    <CountdownClock
      initialSeconds={countdownSeconds}
      label="Completing in..."
      isVisible={showCountdown}
      onComplete={handleComplete}
    />
  );
}

